let count = 1
export function generateId(context = "", prefix = "uicl") {
  return [prefix, context, count++].filter(Boolean).join("-")
}
